import axiosInstance from "./axiosInstance";

const createUser = async (formData: FormData) => {
  try {
    const {data} = await axiosInstance.post("/register", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return data;
  } catch (error: any) {
    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    }
    throw new Error("Error creating user");
  }
};

export default createUser;
